import React from "react";
import { Button } from "components/ui/button";
import ReportGenerator from "./store-filter/report-generator";

interface DownloadReportButtonProps {
  storeCode: string;
  previousBalance: string;
  entries: string;
  exits: string;
  dailyClosing: string;
  dailyBalance: string;
  createdAt: Date;
  buttonText: string;
  treasuryName?: string;
  newResponsibleCpf?: string | null;
}

const DownloadReportButton: React.FC<DownloadReportButtonProps> = ({
  storeCode,
  previousBalance,
  entries,
  exits,
  dailyClosing,
  dailyBalance,
  createdAt,
  buttonText,
  treasuryName,
  newResponsibleCpf,
}) => {
  const generatePdf = ReportGenerator({
    storeCode,
    previousBalance,
    entries,
    exits,
    dailyClosing,
    dailyBalance,
    createdAt,
    treasuryName,
    newResponsibleCpf,
  });

  return (
    <Button onClick={generatePdf} className="mt-4">
      {buttonText}
    </Button>
  );
};

export default DownloadReportButton;
